// extracted by mini-css-extract-plugin
module.exports = {"tabs":"login_tabs__3bxV5","tab":"login_tab__9E375","active":"login_active__2VPDL"};